import type { SectionItemDM } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/common/MultiSectionView.types';
import type { ViewData } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/common/multisection.data';
import { getMultiSectionFigmaLayout } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/common/sections.common';
import { addSection } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/shelf/common/addSection';

export async function addHeroLeft(
  viewData: ViewData,
  section: SectionItemDM
): Promise<ViewData> {
  const layout = getMultiSectionFigmaLayout(viewData);
  return addSection(
    [2, viewData.layoutTable!.length],
    true
  )({
    ...viewData,
    section,
    layout,
  });
}
